<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <v-container>
      <v-row justify="center">
        <v-dialog scrollable v-model="getReportDialog" persistent max-width="1200">
          <material-card :title="$t('views.t4aarchive.T4A Report')" icon="post_add" :color="$vuetify.theme.themes.light.secondary">
            <v-card-text v-if="reportUrl">
              <t4areporttable :identifier="selectedPlan.Id + '_t4aWizardTable'" ref="reportTable" :url="reportUrl" :year="yearId"></t4areporttable>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn
                color="primary"
                @click="closeReportDialog()"
              >{{$t('globals.continue')}}</v-btn>
            </v-card-actions>
          </material-card>
        </v-dialog>
        <v-dialog v-model="hasAdjustmentsDialog" persistent max-width="400">
          <v-card>
            <v-card-title class="headline">{{$t('views.t4aarchive.revise_t4a_report')}}</v-card-title>
            <v-card-text>{{$t('views.t4aarchive.pending_adjustments')}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color text @click="hasAdjustmentsDialog = false">{{$t('globals.cancel')}}</v-btn>
              <v-btn :loading="saving" color="primary" @click="hasAdjustmentsDialog = false; confirmReviseDialog = true;">{{$t('globals.continue')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="confirmReviseDialog" persistent max-width="400">
          <v-card>
            <v-card-title class="headline">{{$t('views.t4aarchive.revise_t4a_report')}}</v-card-title>
            <v-card-text>{{$t('views.t4aarchive.if_you_continue_a_new_revised_report_will_be_created')}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color text @click="confirmReviseDialog = false">{{$t('globals.cancel')}}</v-btn>
              <v-btn :loading="saving" color="primary" @click="revise()">{{$t('globals.revise')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
    <material-card :title="$t('views.t4aarchive.t4a_archive')" :color="$vuetify.theme.themes.light.secondary" icon="post_add">
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        fileNamePrefix="t4a-archive"
        :sortBy="'Year'"
        :sortDescending="true"
        :rowActions="rowActions"
        identifier="t4aArchive"
        :exporters="$exporters"
        @error="error=$event"
      ></pbas-data-table>
      <v-snackbar
        v-model="snackbar"
        :color="color"
        :multi-line="mode === 'multi-line'"
        :timeout="timeout"
        :vertical="mode === 'vertical'"
      >
        {{$t(message)}}
        <v-btn dark text @click="snackbar = false">{{$t('globals.close')}}</v-btn>
      </v-snackbar>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import t4areporttable from "../components/T4AReportTable";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import T4AArchiveHeaders from "../headers/T4AArchive";
import ErrorHandler from "../components/ErrorHandler";
import { planSetter } from "../mixins/planSetter";

export default {
  name: "t4a-archive",
  components: {
    t4areporttable,
    ErrorHandler
  },
  mixins: [planSetter],
  data() {
    return {
      error: null,
      yearId: null,
      saving: false,
      selectedItem: null,
      confirmReviseDialog: false,
      provider: undefined,
      reportUrl: null,
      getReportDialog: false,
      hasAdjustmentsDialog: false,
      rowActions: [
        {
          name: "getReport",
          icon: "file_copy",
          title: "components.getreports.get",
          handler: item => {
            this.reportUrl =
              "plans/" + this.selectedPlan.Id + "/reports/" + item.Id;
            this.yearId = item.YearId;
            this.getReportDialog = true;
          }
        },
        {
          name: "reviseReport",
          icon: "history",
          title: "views.t4a_archive.revise_report",
          handler: async item => {
            this.selectedItem = item;
            var adj = await this.adjustmentsForTaxYear({
              plan: item.PlanId,
              taxYearId: item.YearId
            });
            if(adj && adj.data && adj.data.value && adj.data.value.length > 0){
              this.hasAdjustmentsDialog = true;
            } else {
              this.confirmReviseDialog = true;
            }
          },
          visible: item => !item.IsRevised
        }
      ],
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      premiums: [],
      headers: T4AArchiveHeaders
    };
  },
  computed: {
    ...mapGetters("common", ["messages"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", ["settings"]),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      }
    }
  },
   mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("transactions", ["reviseReport", "adjustmentsForTaxYear"]),
    closeReportDialog() {
      this.$refs.reportTable.provider=undefined;
      this.reportUrl = null
      this.getReportDialog = false
    },
    async loadPlanData() {
      let url = "plans/" + this.selectedPlan.Id + "/t4a/reports/archive";
      this.provider = new PbasOData(this.$axiosHttp, url, this.headers);
    },
    async revise() {
      //console.log(this.selectedItem);
      try {
        this.saving = true;
        await this.reviseReport({
          plan: this.selectedPlan.Id,
          report: this.selectedItem
        });
        this.confirmReviseDialog = false;
        this.$refs.table.getDataAsync();
      } catch (error) {
        console.log(error);
        this.message = "globals.error";
        this.color = "error";
        this.snackbar = true;
      }
      this.saving = false;
    },
    saveHeaders(headerscopy) {
      this.headers = JSON.parse(JSON.stringify(headerscopy));
    }
  }
};
</script>


